import { faCircleCheck } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

interface PushStatusLabelProps {
  isPushLoading: boolean;
  isPushSuccess: boolean;
  isPushError: boolean;
  lastPushedLabel: string | null;
  /** 'default' = gray text (claim summary), 'batch' = white text (batch header) */
  variant: 'default' | 'batch';
}

export const PushStatusLabel = ({
  isPushLoading,
  isPushSuccess,
  isPushError,
  lastPushedLabel,
  variant,
}: PushStatusLabelProps) => {
  if (isPushLoading) return null;

  const textClass =
    variant === 'batch'
      ? 'vai-text-sm vai-text-white vai-font-inter'
      : 'vai-text-sm vai-text-zinc-500 vai-font-inter';

  if (isPushError) {
    return (
      <span className="vai-flex vai-items-center vai-gap-1.5">
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="vai-text-red-500 vai-flex-shrink-0"
        />
        <span className={textClass}>
          {lastPushedLabel ? (
            <Trans>
              Push failed: {lastPushedLabel}. Upload manually to PMS
            </Trans>
          ) : (
            <Trans>Push failed. Upload manually to PMS</Trans>
          )}
        </span>
      </span>
    );
  }

  if (isPushSuccess && lastPushedLabel) {
    return (
      <span className="vai-flex vai-items-center vai-gap-1.5">
        <FontAwesomeIcon
          icon={faCircleCheck}
          className="vai-text-leaf-600 vai-flex-shrink-0"
        />
        <span className={textClass}>
          <Trans>Last pushed: {lastPushedLabel}</Trans>
        </span>
      </span>
    );
  }

  return null;
};
